import CbStep from './src/step.vue';

CbStep.install = function(Vue) {
  Vue.component(CbStep.name, CbStep);
};

export default CbStep;
